module.exports = __webpack_public_path__ + "static/media/external-link-square.fca6f0c8.svg";